module.exports = __webpack_public_path__ + "static/media/RD.b785157b.svg";